
import External from './components/External';

export default {
  i18nComponentKey: 'WidgetReviewsExternal.WidgetReviewsExternalMobile',
  name: 'WidgetReviewsExternalMobile',
  components: { External }
};
